var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.stateView == 0
      ? _c(
          "div",
          { staticClass: "card" },
          [
            _c("div", { staticClass: "card-header" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-theme",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.newTransfer()
                    }
                  }
                },
                [_vm._v("Nuevo")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.critery,
                              expression: "critery"
                            }
                          ],
                          staticClass: "form-control col-md-6",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.critery = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "send" } }, [
                            _vm._v("Localidad que envia")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "rece" } }, [
                            _vm._v("Localidad que recibe")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "date" } }, [
                            _vm._v("Por fecha")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.critery != "date"
                        ? [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.search,
                                  expression: "search"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Ingrese el texto a buscar"
                              },
                              domProps: { value: _vm.search },
                              on: {
                                keyup: function($event) {
                                  return _vm.fetchData(
                                    1,
                                    _vm.search,
                                    _vm.critery,
                                    _vm.transportState
                                  )
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.search = $event.target.value
                                }
                              }
                            })
                          ]
                        : _vm.critery == "date"
                        ? [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("datepicker", {
                                    attrs: {
                                      "bootstrap-styling": true,
                                      format: _vm.customFormatter,
                                      language: _vm.es,
                                      placeholder: "Seleccione fecha"
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-theme",
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              return _vm.fetchData(
                                1,
                                _vm.search,
                                _vm.critery,
                                _vm.transportState
                              )
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-search" }),
                          _vm._v(" search")
                        ]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.transportState,
                            expression: "transportState"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          id: "inlineRadio1",
                          type: "radio",
                          name: "inlineRadioOptions",
                          value: "1"
                        },
                        domProps: { checked: _vm._q(_vm.transportState, "1") },
                        on: {
                          change: [
                            function($event) {
                              _vm.transportState = "1"
                            },
                            function($event) {
                              return _vm.fetchData(
                                1,
                                _vm.search,
                                _vm.critery,
                                _vm.transportState
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio1" }
                        },
                        [_vm._v("Pendiente")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.transportState,
                            expression: "transportState"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          id: "inlineRadio2",
                          type: "radio",
                          name: "inlineRadioOptions",
                          value: "2"
                        },
                        domProps: { checked: _vm._q(_vm.transportState, "2") },
                        on: {
                          change: [
                            function($event) {
                              _vm.transportState = "2"
                            },
                            function($event) {
                              return _vm.fetchData(
                                1,
                                _vm.search,
                                _vm.critery,
                                _vm.transportState
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio2" }
                        },
                        [_vm._v("Completos")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.transportState,
                            expression: "transportState"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          id: "inlineRadio3",
                          type: "radio",
                          name: "inlineRadioOptions",
                          value: "3"
                        },
                        domProps: { checked: _vm._q(_vm.transportState, "3") },
                        on: {
                          change: [
                            function($event) {
                              _vm.transportState = "3"
                            },
                            function($event) {
                              return _vm.fetchData(
                                1,
                                _vm.search,
                                _vm.critery,
                                _vm.transportState
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio2" }
                        },
                        [_vm._v("Incompletos")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.transportState,
                            expression: "transportState",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          id: "inlineRadio4",
                          type: "radio",
                          name: "inlineRadioOptions",
                          value: "0"
                        },
                        domProps: { checked: _vm._q(_vm.transportState, "0") },
                        on: {
                          change: [
                            function($event) {
                              _vm.transportState = "0"
                            },
                            function($event) {
                              return _vm.fetchData(
                                1,
                                _vm.search,
                                _vm.critery,
                                _vm.transportState
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio2" }
                        },
                        [_vm._v("Cancelados")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.transportState,
                            expression: "transportState",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          id: "inlineRadio5",
                          type: "radio",
                          name: "inlineRadioOptions",
                          value: "4"
                        },
                        domProps: { checked: _vm._q(_vm.transportState, "4") },
                        on: {
                          change: [
                            function($event) {
                              _vm.transportState = "4"
                            },
                            function($event) {
                              return _vm.fetchData(
                                1,
                                _vm.search,
                                _vm.critery,
                                _vm.transportState
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "inlineRadio2" }
                        },
                        [_vm._v("Todos")]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "table table-responsive" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.transportArray, function(transport) {
                    return _c("tr", { key: transport.id }, [
                      _c("td", {
                        domProps: {
                          textContent: _vm._s(transport.ticket_number)
                        }
                      }),
                      _vm._v(" "),
                      _c("td", {
                        domProps: {
                          textContent: _vm._s(transport.place_send.name)
                        }
                      }),
                      _vm._v(" "),
                      _c("td", {
                        domProps: {
                          textContent: _vm._s(transport.place_rece.name)
                        }
                      }),
                      _vm._v(" "),
                      transport.description == null
                        ? _c("td", {
                            domProps: { textContent: _vm._s("Sin descripción") }
                          })
                        : _c("td", {
                            domProps: {
                              textContent: _vm._s(transport.description)
                            }
                          }),
                      _vm._v(" "),
                      _c("td", {
                        domProps: {
                          textContent: _vm._s(transport.employee.person.name)
                        }
                      }),
                      _vm._v(" "),
                      _c("td", [
                        transport.state == 0
                          ? _c(
                              "span",
                              { staticClass: "btn btn-danger btn-sm" },
                              [_vm._v("Cancelado")]
                            )
                          : transport.state == 1
                          ? _c("span", { staticClass: "btn btn-info btn-sm" }, [
                              _vm._v("Pendiente")
                            ])
                          : transport.state == 2
                          ? _c(
                              "span",
                              { staticClass: "btn btn-success btn-sm" },
                              [_vm._v("Completo")]
                            )
                          : transport.state == 3
                          ? _c(
                              "span",
                              { staticClass: "btn btn-warning btn-sm" },
                              [_vm._v("Incompleto")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", {
                        domProps: {
                          textContent: _vm._s(transport.transportDate)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group mr-2",
                                attrs: {
                                  role: "group",
                                  "aria-label": "First group"
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Revisar envio",
                                        expression: "'Revisar envio'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-success btn-block",
                                    attrs: {
                                      to:
                                        "/admin/productos/transporte/envio?item=" +
                                        transport.id
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-eye"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("a"),
                                _vm._v(" "),
                                transport.state == 1
                                  ? _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top-center",
                                            value: "Cancelar envio",
                                            expression: "'Cancelar envio'",
                                            modifiers: { "top-center": true }
                                          }
                                        ],
                                        staticClass: "btn btn-danger btn-block",
                                        on: {
                                          click: function($event) {
                                            return _vm.openModal(
                                              "cancel",
                                              transport
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-trash"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "ul",
                    { staticClass: "pagination pagination-primary m-b-0" },
                    [
                      _vm.pagination.current_page > 1
                        ? _c("li", { staticClass: "page-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "page-link",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.changePage(
                                      _vm.pagination.current_page - 1,
                                      _vm.search,
                                      _vm.critery,
                                      _vm.transportState
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-angle-left"
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.pagesNumber, function(page) {
                        return _c(
                          "li",
                          {
                            key: page,
                            staticClass: "page-item",
                            class: [page == _vm.isActived ? "active" : ""]
                          },
                          [
                            _c("a", {
                              staticClass: "page-link",
                              attrs: { href: "#" },
                              domProps: { textContent: _vm._s(page) },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.changePage(
                                    page,
                                    _vm.search,
                                    _vm.critery,
                                    _vm.transportState
                                  )
                                }
                              }
                            })
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.pagination.current_page < _vm.pagination.last_page
                        ? _c("li", { staticClass: "page-item" }, [
                            _c(
                              "a",
                              {
                                staticClass: "page-link",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.changePage(
                                      _vm.pagination.current_page + 1,
                                      _vm.search,
                                      _vm.critery,
                                      _vm.transportState
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon-fa icon-fa-angle-right"
                                })
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "sweet-modal",
              {
                ref: "activate_modal",
                attrs: { icon: "info", "hide-close-button": "", blocking: "" }
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.modalTitleActivate) + "\n      "
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    attrs: { slot: "button", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$refs.activate_modal.close()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("No")]
                ),
                _vm._v(" "),
                _vm.typeAction == 3
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { slot: "button", type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.cancelTransport()
                          }
                        },
                        slot: "button"
                      },
                      [_vm._v("Si")]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.stateView == 1
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-theme",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeTransfer()
                  }
                }
              },
              [_vm._v("Cerrar")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c(
                "tabs",
                { staticClass: "tabs-default" },
                [
                  _c("tab", { attrs: { id: "envio", name: "Envio" } }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Fecha")]),
                              _vm._v(" "),
                              _c("datepicker", {
                                attrs: {
                                  language: _vm.es,
                                  format: _vm.format,
                                  "input-class": "form-control"
                                },
                                model: {
                                  value: _vm.transportDate,
                                  callback: function($$v) {
                                    _vm.transportDate = $$v
                                  },
                                  expression: "transportDate"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Localidad que envía")]),
                              _vm._v(" "),
                              _c("multi-select", {
                                attrs: {
                                  "allow-empty": false,
                                  "show-labels": false,
                                  searchable: true,
                                  options: _vm.placeArray,
                                  label: "name",
                                  "track-by": "id",
                                  placeholder: "Seleccione una localidad"
                                },
                                model: {
                                  value: _vm.placeSend,
                                  callback: function($$v) {
                                    _vm.placeSend = $$v
                                  },
                                  expression: "placeSend"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Localidad que recibe")]),
                              _vm._v(" "),
                              _c("multi-select", {
                                class: {
                                  "is-invalid": _vm.$v.placeRece.$error
                                },
                                attrs: {
                                  "allow-empty": false,
                                  "show-labels": false,
                                  searchable: true,
                                  options: _vm.placeArray,
                                  label: "name",
                                  "track-by": "id",
                                  placeholder: "Seleccione una localidad"
                                },
                                model: {
                                  value: _vm.placeRece,
                                  callback: function($$v) {
                                    _vm.placeRece = $$v
                                  },
                                  expression: "placeRece"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$v.placeRece.$error
                            ? _c("div", [
                                !_vm.$v.placeRece.required
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        "\n                    El campo es requerido\n                  "
                                      )
                                    ])
                                  : _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        "\n                    Las localidades no pueden ser las mismas.\n                  "
                                      )
                                    ])
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Documento")]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control",
                              attrs: { value: "Envio", disabled: "" }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Numero de boleta")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ticketNumber,
                                  expression: "ticketNumber"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", readonly: "" },
                              domProps: { value: _vm.ticketNumber },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.ticketNumber = $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Productos")]),
                              _vm._v(" "),
                              _c("multi-select", {
                                ref: "products",
                                attrs: {
                                  options: _vm.products,
                                  "allow-empty": false,
                                  "show-labels": false,
                                  searchable: true,
                                  loading: _vm.isLoadingProducts,
                                  "internal-search": false,
                                  "custom-label": _vm.nameWithCode,
                                  label: "nameProduct",
                                  "track-by": "idStock",
                                  placeholder: "Seleccione sus productos"
                                },
                                on: {
                                  "search-change": _vm.searchProducts,
                                  close: _vm.addProduct
                                },
                                model: {
                                  value: _vm.product,
                                  callback: function($$v) {
                                    _vm.product = $$v
                                  },
                                  expression: "product"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-1" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Agregar")]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success btn-block",
                                on: { click: _vm.addProduct }
                              },
                              [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Productos")]),
                              _vm._v(" "),
                              _c(
                                "table-component",
                                {
                                  attrs: {
                                    data: _vm.selectProducts,
                                    "show-filter": false,
                                    "table-class": "table"
                                  }
                                },
                                [
                                  _c("table-column", {
                                    attrs: { show: "code", label: "Código" }
                                  }),
                                  _vm._v(" "),
                                  _c("table-column", {
                                    attrs: {
                                      show: "nameProduct",
                                      label: "Producto"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("table-column", {
                                    attrs: {
                                      show: "stock",
                                      label: "Existencia"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.myquantity(row["stock"])
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      570640543
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("table-column", {
                                    attrs: {
                                      sortable: false,
                                      filterable: false,
                                      label: "Cantidad"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(row) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.number",
                                                    value:
                                                      _vm.selectProducts[
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      ].quantity,
                                                    expression:
                                                      "selectProducts[getIndex(selectProducts,row['id'])].quantity",
                                                    modifiers: { number: true }
                                                  }
                                                ],
                                                ref:
                                                  "quantity-" +
                                                  _vm.getIndex(
                                                    _vm.selectProducts,
                                                    row["id"]
                                                  ),
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid":
                                                    _vm.selectProducts[
                                                      _vm.getIndex(
                                                        _vm.selectProducts,
                                                        row["id"]
                                                      )
                                                    ].error === true
                                                },
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    _vm.selectProducts[
                                                      _vm.getIndex(
                                                        _vm.selectProducts,
                                                        row["id"]
                                                      )
                                                    ].quantity
                                                },
                                                on: {
                                                  blur: [
                                                    function($event) {
                                                      _vm.validateQuantity(
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  ],
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.selectProducts[
                                                        _vm.getIndex(
                                                          _vm.selectProducts,
                                                          row["id"]
                                                        )
                                                      ],
                                                      "quantity",
                                                      _vm._n(
                                                        $event.target.value
                                                      )
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2192772194
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("table-column", {
                                    attrs: {
                                      sortable: false,
                                      filterable: false,
                                      label: "Acciones"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "btn-group mr-2",
                                                  attrs: {
                                                    role: "group",
                                                    "aria-label": "First group"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-danger",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeProduct(
                                                            _vm.getIndex(
                                                              _vm.selectProducts,
                                                              row["id"]
                                                            )
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-fa icon-fa-trash"
                                                      }),
                                                      _vm._v(
                                                        "\n                            Quitar\n                          "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3293180150
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-9" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Comentario")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.description,
                                  expression: "description"
                                }
                              ],
                              ref: "description",
                              staticClass: "form-control",
                              attrs: {
                                placeholder: "Comentario sobre el envio"
                              },
                              domProps: { value: _vm.description },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.description = $event.target.value
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v(" ")]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                ref: "buttonSave",
                                staticClass:
                                  "btn btn-block btn-theme ladda-button",
                                attrs: {
                                  slot: "button",
                                  "data-style": "expand-right"
                                },
                                on: {
                                  click: _vm.saveTransport,
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.saveTransport.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                },
                                slot: "button"
                              },
                              [_vm._v("Guardar traslado")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Trasladar producto")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Trasladar producto")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Envia")]),
        _vm._v(" "),
        _c("th", [_vm._v("Recibe")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripcion")]),
        _vm._v(" "),
        _c("th", [_vm._v("Empleado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de registro")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33d50918", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33d50918","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/transport/Transport.vue
// module id = 570
// module chunks = 0